<template>
  <figure :style='{ opacity: dynamicOpacity }'>
    <img :class='"composition-"+randomIntFromInterval(1,4)' v-once  :src='".././images/darkroom-burn-"+ randomIntFromInterval(1,2) +".png"'  />
  </figure>
</template>

<script>
import mixins from '.././mixins.js';

export default {
  mixins: [mixins], //kirby(), urltopath(), md() etc
  props: ['scroll'],
  data () {
    return {
      timerOn: false,
      dynamicOpacity: 0,
      timer: 0
    }
  },
  mounted: function() {
    this.start();
  },
  methods: {
    start () {
      this.timer = setInterval(this.tick, 1100);
    },
    tick () {
      //console.log('tick');
      this.dynamicOpacity = ( this.dynamicOpacity + 0.1 < 1 ) ? this.dynamicOpacity + 0.1 : 1;
    },
    onScrollChange () {
      clearInterval(this.timer);
      this.dynamicOpacity = 0;
      this.timerOn = true;
      this.timeout = setTimeout(this.start(), 7500);
    },
    randomIntFromInterval(min, max) { // min and max included
      return Math.floor(Math.random() * (max - min + 1) + min)
    }
  },
  watch: {
    scroll: {
      handler: 'onScrollChange'
    }
  },
}
</script>

<style scoped>
  figure {
      position: fixed;
      width: 100vw;
      height: 100vh;
      top: 0;
      right: 0;
      left: 0;
      right: 0;
      box-sizing: border-box;
      mix-blend-mode: multiply;
      z-index: 3;
      pointer-events: none;
      transition: opacity 999ms linear;
      transform: translate3d(0,0,0);
      backface-visibility: hidden;
  }

  figure img {
    position: absolute;
  }

  figure img.composition-1 {
    left: 0;
    top: 0;
  }

  figure img.composition-2 {
    left: 0;
    top: -70vh;
    transform: scale(0.4, -0.4);
    transform-origin: left;
  }

  figure img.composition-3 {
    right: -1vw;
    top: -100vh;
    transform: scale(-1);
    transform-origin: center;
  }

  figure img.composition-4 {
    left: -10vw;
    top: 50vh;
  }
</style>
